<template>
    <el-tabs v-model="activeTab" :before-leave="beforeLeave" class="dz-tab" @tab-click="tabClick">
        <el-tab-pane v-for="(tab, index) in tabs" :key="index" :name="tab.tab">
            <span slot="label" class="tab-item">
                <i v-if="tab.icon" :class="tab.icon"></i>
                <img v-if="tab.img" :src="tab.img" alt="" />
                {{ tab.name }}
                <badge v-if="tab.badge" :txt="tab.badge" />
            </span>
        </el-tab-pane>
        <slot></slot>
    </el-tabs>
</template>

<script>
import badge from '../badge/index.vue';

export default {
    name: 'DzTab',
    components: {
        badge,
    },

    props: {
        useRoute: {
            type: Boolean,
            default: true,
        },
        name: String,
        active: String,
        tabs: Array,
    },
    data() {
        return {
            activeTab: this.active,
        };
    },
    watch: {
        activeTab() {
            this.$emit('update:active', this.activeTab);
        },
    },
    created() {},
    mounted() {
        if (this.useRoute) {
            this.activeTab = this.$route.name;
            this.$watch('$route.name', {
                handler(name) {
                    this.activeTab = name;
                },
            });
        } else {
            this.activeTab = this.$route.query[this.name] || this.activeTab;
            this.$watch('$route.query', {
                handler(query) {
                    const activeTab = query[this.name];
                    if (activeTab && this.activeTab !== activeTab) {
                        this.activeTab = activeTab;
                    }
                },
            });
        }
    },
    methods: {
        tabClick() {
            if (this.useRoute) {
                this.$router.push({
                    name: this.activeTab,
                    // query: { ...this.$route.query, [this.name]: this.activeTab },
                });
                this.$nextTick(() => {
                    this.activeTab = this.$route.name;
                });
            } else if (this.$route.query[this.name] !== this.activeTab) {
                this.$router.replace({
                    name: this.activeTab,
                    query: { ...this.$route.query, [this.name]: this.activeTab },
                });
            }
        },
        beforeLeave(activeName) {
            if (/^https?:\/\//.test(activeName)) {
                window.open(activeName, '_blank');
                return false;
            }
        },
    },
};
</script>

<style lang="scss">
// TODO tab样式
.dz-tab {
    .el-tabs__header {
        background-color: #fff;
        margin-bottom: 10px;
    }

    .el-tabs__nav-wrap::after {
        height: 1px;
    }

    .el-tabs__nav {
        .el-tabs__item {
            font-size: 16px;
            height: 50px;
            line-height: 50px;
        }
    }

    .tab-item {
        padding: 0 20px;
        img {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            margin-bottom: 2px;
        }
    }
}
</style>
